import { StatusDot } from '@astryxdesign/core/StatusDot';
import { HStack } from '@astryxdesign/core/Stack';
import { Text } from '@astryxdesign/core/Text';

type Variant = 'success' | 'warning' | 'neutral' | 'error' | 'accent';

/** Статус с видимой подписью: StatusDot в Astryx показывает только точку, label уходит в доступное имя. */
export function StatusLabel({ variant, label }: { variant: Variant; label: string }) {
  return (
    <HStack gap={1.5} align="center">
      <StatusDot variant={variant} label={label} />
      <Text color="secondary" aria-hidden>
        {label}
      </Text>
    </HStack>
  );
}
